import styled from '@emotion/styled'
import { SashContent } from 'split-pane-react'

import { colors } from '@/styles'

export const Sash = styled(SashContent)`
	background-color: ${colors.layout.tabContentBackgroundColor};
	border: 1px solid ${colors.layout.borderColor};
`

export const DisabledSash = styled.div`
	width: 100%;
	height: 100%;
	pointer-events: none;
	cursor: default;
`
